module.exports = __webpack_public_path__ + "static/media/IMG_1339.37d36646.JPG";